import { Steppr } from './client';

// When loaded via <script>, attach to window and auto-init if data attrs present.
declare global {
  interface Window {
    Steppr?: typeof Steppr;
    stepprq?: unknown[];
  }
}

window.Steppr = Steppr;

// Drain any queued calls made before this script loaded.
// e.g. `window.stepprq = window.stepprq || []; stepprq.push(['init', {...}]);`
const queue = (window.stepprq ?? []) as Array<[keyof typeof Steppr, ...unknown[]]>;
for (const [method, ...args] of queue) {
  const fn = Steppr[method] as (...a: unknown[]) => unknown;
  if (typeof fn === 'function') fn.apply(Steppr, args);
}
window.stepprq = { push: (item: [keyof typeof Steppr, ...unknown[]]) => {
  const [method, ...rest] = item;
  const fn = Steppr[method] as (...a: unknown[]) => unknown;
  if (typeof fn === 'function') fn.apply(Steppr, rest);
  return 0;
} } as unknown as unknown[];

// Auto-init from script data attributes if present:
// <script src="steppr.js" data-project-key="stp_live_..."></script>
const thisScript = document.currentScript as HTMLScriptElement | null;
if (thisScript?.dataset.projectKey) {
  Steppr.init({
    projectKey: thisScript.dataset.projectKey,
    apiUrl: thisScript.dataset.apiUrl,
  });
}

export { Steppr };
